export const AGGREGATED_APP_DATA = 'AGGREGATED_APP_DATA';
